export const locale = {
  lang: 'fr',
  data: {
    DASHBOARD: {
      LOADING: {
        TITLE: 'Chargement du Tableau de Bord',
        SUBTITLE: 'Veuillez patienter pendant que nous récupérons vos données...'
      },
      WELCOME: 'Bienvenue',
      ADMINISTRATOR: 'Administrateur',
      ACADEMIC_YEAR: 'Année Académique',
      SEMESTER: 'Semestre',
      SEQUENCE: 'Séquence',
      SYSTEM_STATUS: 'État du Système',
      OPERATIONAL: 'Opérationnel',
      ORGANIZATION_OVERVIEW: {
        TITLE: 'Aperçu de l\'Organisation'
      },
      STATS: {
        TOTAL_LEARNERS: 'Total Apprenants',
        TOTAL_STAFF: 'Total Personnel',
        RESOURCES: 'Ressources',
        TOTAL_COURSES: 'Total Cours',
        ACTIVE: 'Actif',
        INACTIVE: 'Inactif',
        ON_LEAVE: 'En Congé',
        NEW_HIRES: 'Nouveaux Recrutés',
        CLASSROOMS: 'Salles de Classe',
        DEPARTMENTS: 'Départements',
        ACTIVE_ENROLLMENT: 'Inscription Active',
        GROWTH: 'Croissance',
        ENROLLED_LEARNERS: 'Apprenants Inscrits',
        ACTIVE_CLASSROOMS: 'Classes Actives',
        FACULTY_MEMBERS: 'Membres du Personnel',
        TOTAL_FEES_COLLECTED: 'Total Frais Collectés',
        GROWTH_THIS_MONTH: 'Croissance ce mois',
        GROWTH_THIS_TERM: 'Croissance ce trimestre'
      },
      FINANCIAL_OVERVIEW: {
        TITLE: 'Aperçu Financier',
        VIEW_DETAILS: 'Voir les Détails',
        TOTAL_EXPECTED: 'Total Attendu',
        COLLECTED: 'Collecté',
        OUTSTANDING: 'En Souffrance',
        DUE: 'Dû',
        REMAINING: 'Restant',
        MONTHLY_REVENUE_TREND: 'Tendance des Revenus Mensuels',
        COLLECTION_RATE: 'Taux de Recouvrement',
        FEE_DISTRIBUTION: 'Distribution des Frais',
        MONTHLY_COLLECTION_TREND: 'Tendance de Collecte Mensuelle',
        TOTAL_FEE_AMOUNT: 'Montant Total des Frais',
        OUTSTANDING_AMOUNT: 'Montant en Souffrance'
      },
      RECENT_TRANSACTIONS: {
        TITLE: 'Transactions Récentes',
        VIEW_ALL: 'Voir Tout',
        STUDENT: 'Étudiant',
        ID: 'ID',
        METHOD: 'Méthode',
        STATUS: 'Statut',
        AMOUNT: 'Montant',
        RECEIPT_NUMBER: 'Numéro de Reçu',
        LEARNER: 'Apprenant',
        DATE: 'Date'
      },
      ACADEMICS: {
        TITLE: 'Académiques',
        FULL_REPORT: 'Rapport Complet',
        AVG_CLASS_SCORE: 'Score Moyen de Classe',
        RESULTS_PUBLISHED: 'Résultats Publiés',
        TOP_PERFORMING_CLASSES: 'Classes les Plus Performantes'
      },
      ASSIGNMENTS: {
        TITLE: 'Statistiques des Devoirs',
        TOTAL: 'Total',
        ACTIVE: 'Actif',
        PENDING: 'En Attente',
        OVERDUE: 'En Retard',
        AVG_COMPLETION_RATE: 'Taux de Complétion Moyen'
      },
      ACTIVITY: {
        TITLE: 'Activité Système Récente',
        NEW_LEARNER_ENROLLMENT: 'Nouvelle Inscription d\'Apprenant',
        RESULTS_PUBLISHED: 'Résultats Publiés',
        SYSTEM_ALERT: 'Alerte Système'
      },
      SYSTEM_HEALTH: {
        TITLE: 'Santé du Système',
        DATA_COMPLETENESS: 'Complétude des Données',
        SERVER_UPTIME: 'Disponibilité du Serveur'
      },
      CALENDAR: {
        TITLE: 'Calendrier',
        UPCOMING_EVENTS: 'Événements à Venir',
        VIEW_FULL_CALENDAR: 'Voir le Calendrier Complet',
        WEEKDAYS: {
          SUN: 'Di',
          MON: 'Lu',
          TUE: 'Ma',
          WED: 'Me',
          THU: 'Je',
          FRI: 'Ve',
          SAT: 'Sa'
        },
        EVENTS: {
          FACULTY_MEETING: 'Réunion du Personnel',
          PARENT_TEACHER_CONFERENCE: 'Conférence Parents-Enseignants',
          END_OF_TERM_EXAMS: 'Examens de Fin de Trimestre',
          CONFERENCE_ROOM: 'Salle de Conférence',
          MAIN_HALL: 'Salle Principale',
          ALL_CLASSROOMS: 'Toutes les Salles'
        }
      },
      PENDING_APPROVALS: {
        TITLE: 'Approbations en Attente',
        LEAVE_REQUEST: 'Demande de Congé',
        COURSE_SYLLABUS: 'Programme du Cours',
        REVIEW_DOCUMENT: 'Examiner le Document'
      },
      ALERTS: {
        TITLE: 'Alertes Système'
      },
      QUICK_ACTIONS: {
        TITLE: 'Actions Rapides',
        COURSES: 'Cours',
        LEARNERS: 'Apprenants',
        EVALUATIONS: 'Évaluations',
        FEES: 'Frais',
        REPORTS: 'Rapports',
        REFRESH: 'Actualiser',
        NEW_STUDENT: 'Nouvel Étudiant',
        NEW_STAFF: 'Nouveau Personnel',
        RECORD_PAYMENT: 'Enregistrer Paiement',
        TAKE_ATTENDANCE: 'Prendre Présence',
        ADD_GRADES: 'Ajouter Notes',
        GENERATE_REPORT: 'Générer Rapport'
      },
      CLASSROOM_DISTRIBUTION: {
        TITLE: 'Distribution des Classes',
        VIEW_ALL_CLASSES: 'Voir Toutes les Classes',
        STUDENTS_PER_CLASSROOM: 'Étudiants par Classe',
        AVERAGE_CLASS_SIZE: 'Taille Moyenne de Classe',
        TOTAL_CLASSES: 'Total des Classes',
        LARGEST_CLASS: 'Plus Grande Classe'
      }
    },
    COMMON: {
      APPROVE: 'Approuver',
      DENY: 'Refuser',
      LOADING: 'Chargement...',
      NOT_AVAILABLE: 'N/D'
    }
  }
};
